// External Packages
import { useState, Fragment, useEffect } from "react";

// Internal Packages
import { BsFilter } from "react-icons/bs";
import { truncate } from "../../util/format-text";

export default function FilterMenu({ onSubmit, options }) {
  const [show, setShow] = useState(false);
  const [filters, setFilters] = useState();

  const submitHandler = (event) => {
    event.preventDefault();
    let response = {};
    options.forEach((option) => {
      const label = option.label.toLowerCase();
      if (option.type === "multiple") {
        response[label] = "";
        option.options.forEach((option) => {
          if (event.target[option.value ?? option].checked)
            response[label] += `${option.value ?? option},`;
        });
        // Remove trailing comma
        if (response[label]) response[label] = response[label].slice(0, -1);
      } else {
        response[label] = event.target[option.label].value;
      }
    });
    onSubmit && onSubmit(response);
    setShow(false);
  };

  useEffect(() => {
    let newFilters = 0;
    options.forEach((option) => {
      if (option.type === "multiple") {
        if (option.selected) newFilters++;
      } else if (
        option.selected !== (option.options[0].value ?? option.options[0])
      )
        newFilters++;
    });
    if (newFilters) setFilters(newFilters);
    else setFilters();
  }, [options]);

  return (
    <Fragment>
      <div className="relative">
        <div onClick={() => setShow(!show)} className="cursor-pointer">
          {filters && (
            <p className="absolute left-0 top-0 text-[8px] rounded-full bg-primary px-1">
              {filters}
            </p>
          )}
          <BsFilter
            className="text-2xl text-white hover:text-stone-400"
            title="Add Filters"
          />
        </div>
        {show && (
          <form
            onSubmit={submitHandler}
            className={`absolute top-0 z-10 grid gap-4 p-4 text-xs text-left rounded-lg text-stone-200 right-8 bg-stone-700`}
          >
            <div className="flex space-x-4">
              <div className="grid content-start w-full gap-2">
                {options
                  ?.filter((a) => a.type !== "multiple")
                  .map((option, idx) => (
                    <div key={idx} className="grid gap-1">
                      <p className="font-semibold">{option.label}</p>
                      <select
                        className="form-input"
                        name={option.label}
                        defaultValue={option.selected}
                      >
                        {option.options.map((opt, idx) => (
                          <option key={idx} value={opt.value || opt}>
                            {truncate(opt.label ?? opt, 20)}
                          </option>
                        ))}
                      </select>
                    </div>
                  ))}
              </div>
              <div className="flex w-full space-x-4">
                {options
                  .filter((a) => a.type === "multiple")
                  ?.map((option, idx) => (
                    <div
                      key={idx}
                      className="grid content-start gap-1 min-w-[120px] whitespace-nowrap"
                    >
                      <p className="font-semibold">{option.label}</p>
                      <MultiSelect
                        options={option.options}
                        selected={option.selected}
                      />
                    </div>
                  ))}
              </div>
            </div>

            <div
              className={`${options.length > 4 ? "grid grid-cols-2 gap-4" : "grid gap-2"}`}
            >
              <button type="submit" className="mt-auto btn-primary">
                Apply
              </button>
              <div className="btn-warning" onClick={() => setShow(false)}>
                Cancel
              </div>
            </div>
          </form>
        )}
      </div>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="absolute top-0 left-0 w-[100vw] h-[100vh] cursor-pointer bg-stone-900 z-1 opacity-20"
        />
      )}
    </Fragment>
  );
}

/** ========================================================================
 * * Multiple Select Dropdown Component
 * ========================================================================== */
const MultiSelect = ({ options, selected }) => {
  const selectedArray = selected ? selected.split(",") : [];

  const selectAll = () => {
    options.forEach((option) => {
      document.getElementById(option.value ?? option).click();
    });
  };

  const clearAll = () => {
    options.forEach((option) => {
      if (document.getElementById(option.value ?? option).checked)
        document.getElementById(option.value ?? option).click();
    });
  };
  return (
    <div className="grid gap-1">
      <div className="flex space-x-4">
        <p
          className="text-xs cursor-pointer text-stone-400 hover:underline"
          onClick={selectAll}
        >
          Select All
        </p>
        <p
          className="text-xs cursor-pointer text-stone-400 hover:underline"
          onClick={clearAll}
        >
          Clear All
        </p>
      </div>

      {options.map((option, idx) => (
        <div
          key={idx}
          className="flex items-center space-x-2 cursor-pointer hover:opacity-80"
        >
          <input
            type="checkbox"
            id={option.value || option}
            defaultChecked={
              selectedArray.includes(option.value || option) || false
            }
            className="checkbox"
          />
          <p
            className="text-xs text-stone-200"
            onClick={() =>
              document.getElementById(option.value ?? option).click()
            }
          >
            {option.label ?? option}
          </p>
        </div>
      ))}
    </div>
  );
};
